'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _components = require('@rebass/components');

var _components2 = _interopRequireDefault(_components);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Arrow = exports.Arrow = (0, _components2.default)({
  direction: 'down'
}, function (props) {
  var borderTop = props.direction === 'down' ? {
    borderTop: '.4375em solid'
  } : null;
  var borderBottom = props.direction === 'up' ? {
    borderBottom: '.4375em solid'
  } : null;
  return _extends({
    display: 'inline-block',
    width: 0,
    height: 0,
    verticalAlign: 'middle',
    borderRight: '.3125em solid transparent',
    borderLeft: '.3125em solid transparent'
  }, borderTop, borderBottom);
}, 'space', 'color');
Arrow.displayName = 'Arrow';
exports.default = Arrow;